import styled from 'astroturf/react';

export const Choice = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 0px 8px 10px;
`;

export const ChoiceText = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

export const OtherTextInput = styled.input`
  width: 100%;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  background-color: transparent;
  border: none;
  border-bottom: 2px solid #d9d9d9;

  &::placeholder {
    color: unset;
    opacity: 1;
  }
`;

export const ChoiceSelector = styled.div`
  margin-right: 16px;
`;
